module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += 'function _almostEq(val, expectedVal, absErr = 1e-12, relErr = 1e-5) {\n	const err = Math.abs(expectedVal)*relErr + absErr;\n	return Math.abs(expectedVal - val) < err;\n}\n\n/* Use object destructuring for testing optional argument passing*/\nfunction almostEq(t, val, expectedVal, {message, absErr, relErr}={message: "", absErr: 1e-12, relErr: 1e-5}) {\n	const err = Math.abs(expectedVal)*relErr + absErr;\n	t.true(_almostEq(val, expectedVal, absErr, relErr), message + \'\\n\' +\n		`value is ' +
((__t = (val)) == null ? '' : __t) +
', expected ' +
((__t = (expectedVal)) == null ? '' : __t) +
', error margin is ' +
((__t = (err)) == null ? '' : __t) +
'`);\n}\n\n\nmodule.exports = almostEq;';

}
return __p
}